import { facadeApi } from 'api'
import { TransferFileDTO, TransferFileResponse } from 'types/files/files'

export const moveFileApi = (data: TransferFileDTO) =>
  facadeApi.post<TransferFileResponse>('/file-manager/v1/move', data)
